
export default {
  name: 'CartStockBadge',

  props: {
    variant: {
      type: Object,
      required: true,
    },

    quantity: {
      type: Number,
      default: 1,
    },

    readOnly: {
      type: Boolean,
      default: false,
    },
  },
}
